import React from "react"
import { Link } from "gatsby"
import YouTube from "react-youtube"

import Layout from "../../components/layout"
import SEO from "../../components/seo"

// https://developers.google.com/youtube/player_parameters
const opts = {
  height: "348",
  width: "640",
  playerVars: {
    autoplay: 0,
  },
}

const VideoGrowPage = () => {
  return (
    <Layout>
      <SEO
        title="Grow video"
        description="A stop-motion animation presents a galloping horse which sculpts itself."
        bodyClass="greyBackground"
      />
      <div style={{ padding: "10px 0" }}>
        <Link to="/" style={{ color: "black" }}>
          back
        </Link>
      </div>
      <div style={{ textAlign: "center" }}>
        <YouTube
          // onPlay={() => console.log()}
          opts={opts}
          videoId="buByCclhQ4E"
        />
      </div>
    </Layout>
  )
}

export default VideoGrowPage
